import { IModel } from './index';

export class PaginatedList<T extends IModel> {

    constructor(public totalCount: number,
                public list: T[]) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/paginated-list.ts